import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7771f832&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./nutritionPlanList.scss?vue&type=style&index=0&id=7771f832&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7771f832",
  null
  
)

export default component.exports